import axios from 'axios';

export const KBKService = {
  async getKBK(pagination) {
    const { page, perPage } = pagination;
    const res = await axios.get('kbk/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createKBK(data) {
    const res = await axios.post('kbk/', data);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },
  async deleteKBK(id) {
    const res = await axios.delete(`kbk/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async updateKBK(data, id) {
    const res = await axios.put(`kbk/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
